var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05371 14.291C6.48633 14.291 7.47949 14.8008 7.91895 15.0996C8.06836 15.1875 8.48145 15.4424 8.57812 15.4688V1.88965C7.97168 0.834961 6.29297 0 4.58789 0C2.3291 0 0.483398 1.27441 0 2.23242V14.5723C0 15.3018 0.421875 15.5918 0.922852 15.5918C1.30078 15.5918 1.53809 15.4688 1.79297 15.2754C2.30273 14.8359 3.50684 14.291 5.05371 14.291ZM13.2715 14.291C14.8184 14.291 16.0225 14.8359 16.541 15.2754C16.7783 15.46 17.0244 15.5918 17.3936 15.5918C17.9033 15.5918 18.3252 15.3018 18.3252 14.5723V2.23242C17.8418 1.27441 16.0049 0 13.7461 0C12.0322 0 10.3623 0.834961 9.74707 1.88965V15.4775C9.85254 15.4512 10.2568 15.1963 10.4238 15.0996C10.8545 14.8008 11.8477 14.291 13.2715 14.291Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryIcon);
export default __webpack_public_path__ + "static/media/library-icon.e7ad69fde5bc05679203aaa58d182d49.svg";
export { ForwardRef as ReactComponent };